import * as React from 'react';
import PropTypes from 'prop-types';

const ExpandButtonLeftIcon = ({ color = 'rgb(133, 137, 145)', ...rest }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M14 18C13.7 18 13.5 17.9 13.3 17.7L8.3 12.7C7.9 12.3 7.9 11.7 8.3 11.3L13.3 6.3C13.7 5.9 14.3 5.9 14.7 6.3C15.1 6.7 15.1 7.3 14.7 7.7L10.4 12L14.7 16.3C15.1 16.7 15.1 17.3 14.7 17.7C14.5 17.9 14.3 18 14 18Z"
      fill={color}
    />
  </svg>
);
export default ExpandButtonLeftIcon;

ExpandButtonLeftIcon.propTypes = {
  color: PropTypes.string,
};
